

const initialState = {
    AllDomain:[]
  
  }
  
  const DomainReducer = (state = initialState, action) => {
    const { type, payload } = action
    
    switch (type) {
      case 'SET_ALL_DOMAIN': {
        return {
          ...state,
          AllDomain: payload,
        
        }
      }
  
  
      default:
        return state
    }
  }
  
  export default DomainReducer